import assetPath from '/app/packages/lebenslauf/articles/src/assets/aufloesung.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')